
// workAreas/hooks/useWorkAreaState.js
import { useState, useEffect } from 'react';

export const useWorkAreaState = (allWorkAreas) => {
  const [expandedWorkAreas, setExpandedWorkAreas] = useState({});
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [isCreating, setIsCreating] = useState(false);

  // Auto-expand if only one work area
  useEffect(() => {
    if (allWorkAreas.length === 1) {
      setExpandedWorkAreas({ [allWorkAreas[0].slug]: true });
    }
  }, [allWorkAreas.length]);

  const handleToggleWorkArea = (workAreaSlug) => {
    setExpandedWorkAreas(prev => {
      const newState = { ...prev };
      if (newState[workAreaSlug]) {
        delete newState[workAreaSlug];
      } else {
        newState[workAreaSlug] = true;
      }
      return newState;
    });
  };

  const handleCloseCreateDialog = () => setShowCreateDialog(false);

  return {
    expandedWorkAreas,
    showCreateDialog,
    isCreating,
    setIsCreating,
    handleToggleWorkArea,
    handleCloseCreateDialog,
    setShowCreateDialog
  };
};